import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LogOut, User2, HeartPulse, Star, ClipboardPlus } from "lucide-react";
import { ageString, formatDMY } from "./shared";
import { mediaUrl } from "@/lib/media";

function ChipGroup({ items, cls }) {
  if (!items || items.length === 0) return <p className="text-sm text-slate-400">—</p>;
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((x, i) => <span key={i} className={`rounded-full px-3 py-1.5 text-sm font-medium ${cls}`}>{x}</span>)}
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between border-b border-slate-100 py-3 last:border-0">
      <span className="text-sm text-slate-500">{label}</span>
      <span className="text-sm font-semibold text-slate-900">{value || "—"}</span>
    </div>
  );
}

export default function ProfileView({ student, user, onLogout }) {
  if (!student) return <p className="py-20 text-center text-sm text-slate-400" data-testid="parent-profile">Öğrenci bulunamadı.</p>;
  return (
    <div className="pb-4" data-testid="parent-profile">
      {/* gradient header */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-violet-600 via-indigo-500 to-blue-500 px-6 pb-8 pt-10 text-center shadow-[0_10px_30px_rgba(79,70,229,0.3)]">
        <div className="mx-auto w-fit">
          {student.photo_url ? <img src={mediaUrl(student.photo_url)} alt="" className="h-24 w-24 rounded-full border-4 border-white/80 object-cover" />
            : <div className="flex h-24 w-24 items-center justify-center rounded-full border-4 border-white/80 bg-white/25 text-3xl font-bold text-white">{student.full_name.charAt(0)}</div>}
        </div>
        <h1 className="mt-3 font-heading text-2xl font-bold text-white">{student.full_name}</h1>
        <p className="text-sm text-white/85">{ageString(student.birth_date)}</p>
      </div>

      <section className="mt-6">
        <h2 className="mb-2 flex items-center gap-2 font-heading font-bold text-slate-900"><User2 className="h-4 w-4 text-violet-600" /> Demografik Bilgiler</h2>
        <Card className="rounded-2xl border-slate-200/60 px-4 py-1 shadow-[0_2px_10px_rgba(0,0,0,0.04)]">
          <Row label="Ad Soyad" value={student.full_name} />
          <Row label="Cinsiyet" value={student.gender} />
          <Row label="Doğum Tarihi" value={formatDMY(student.birth_date)} />
          <Row label="Yaş" value={ageString(student.birth_date)} />
        </Card>
      </section>

      <section className="mt-6">
        <h2 className="mb-2 flex items-center gap-2 font-heading font-bold text-slate-900"><ClipboardPlus className="h-4 w-4 text-violet-600" /> Tanı Bilgisi</h2>
        <Card className="rounded-2xl border-slate-200/60 p-4 text-[15px] text-slate-800 shadow-[0_2px_10px_rgba(0,0,0,0.04)]">{student.diagnosis || "—"}</Card>
      </section>

      <section className="mt-6">
        <h2 className="mb-2 flex items-center gap-2 font-heading font-bold text-slate-900"><HeartPulse className="h-4 w-4 text-violet-600" /> Aldığı Hizmetler</h2>
        <Card className="rounded-2xl border-slate-200/60 p-4 shadow-[0_2px_10px_rgba(0,0,0,0.04)]"><ChipGroup items={student.services} cls="bg-blue-50 text-blue-700" /></Card>
      </section>

      <section className="mt-6">
        <h2 className="mb-2 flex items-center gap-2 font-heading font-bold text-slate-900"><Star className="h-4 w-4 text-emerald-600" /> Güçlü Yönleri</h2>
        <Card className="rounded-2xl border-slate-200/60 p-4 shadow-[0_2px_10px_rgba(0,0,0,0.04)]"><ChipGroup items={student.strengths} cls="bg-emerald-50 text-emerald-700" /></Card>
      </section>

      <section className="mt-6">
        <h2 className="mb-2 flex items-center gap-2 font-heading font-bold text-slate-900"><HeartPulse className="h-4 w-4 text-amber-600" /> Destek Gerektiren Alanlar</h2>
        <Card className="rounded-2xl border-slate-200/60 p-4 shadow-[0_2px_10px_rgba(0,0,0,0.04)]"><ChipGroup items={student.support_areas} cls="bg-amber-50 text-amber-700" /></Card>
      </section>

      <section className="mt-6">
        <h2 className="mb-2 flex items-center gap-2 font-heading font-bold text-slate-900"><User2 className="h-4 w-4 text-violet-600" /> Veli Hesabı</h2>
        <Card className="rounded-2xl border-slate-200/60 px-4 py-1 shadow-[0_2px_10px_rgba(0,0,0,0.04)]">
          <Row label="Ad Soyad" value={user?.name} />
          <Row label="E-posta" value={user?.email} />
        </Card>
      </section>

      <Button onClick={onLogout} data-testid="parent-logout" variant="outline"
        className="mt-6 h-12 w-full rounded-2xl border-red-200 bg-white text-base font-semibold text-red-600 hover:bg-red-50">
        <LogOut className="mr-2 h-5 w-5" /> Çıkış Yap
      </Button>
      <p className="mt-4 text-center text-xs text-slate-400">Renka v1.0.0</p>
    </div>
  );
}
